<table style="width: 100%" class="select-table">
  <thead>
    <tr>
      <th>Task #</th>
      <th>Reg. #</th>
      <th>Job #</th>
      <th>Status</th>
    </tr>
  </thead>
  <tbody>
    <tr
      [class.selected]="selectedTask?.id == task.id && jobInfo?.tasks?.length > 1"
      [class.prepop]="selectedTask?.id == task.id && jobInfo?.tasks?.length == 1"
      *ngFor="let task of jobInfo.tasks; let i = index"
      (click)="onTaskClick(task, i)"
    >
      <td>{{ i + 1 }}</td>
      <td>{{ task.registrationNumber }}</td>
      <td>{{ jobInfo?.jobNumber }}</td>
      <td>{{ jobInfo?.statusText }}</td>
    </tr>
  </tbody>
</table>
